// extracted by mini-css-extract-plugin
export default {"text":"Invite_text__qRNrz","warning":"Invite_warning__sArYS","icon":"Invite_icon__WtGqZ"};